import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes__default from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { hexToRgb } from '../../theme/theme.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import StreamlineIcon from '../streamline-icon/StreamlineIcon.js';
import SvgButtonPlay from '../../common/streamlinehq/img/streamline-regular/interface-essential/multimedia-controls/button-play.svg.js';
import { ONETRUST_COOKIES_CATEGORIES } from '../../common/constant.js';
import { retrieveContentfulImage } from '../../common/image.js';
import Youtube from 'react-youtube';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      overflow: "hidden",
      paddingBottom: "56.25%",
      position: "relative",
      width: "100%",
      borderRadius: theme.spacing(1)
    }, theme.breakpoints.only("sm"), {
      paddingBottom: "100%"
    }),
    videoResponsive: {
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      position: "absolute"
    },
    ytVideoThumb: {
      width: "100%",
      height: "100%"
    },
    playerIcon: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: theme.spacing(6),
      color: theme.palette.text["white"]
    },
    descriptionText: _objectSpread(_objectSpread({}, theme.typography.infoMessage), {}, {
      color: hexToRgb(theme.palette.text.black, theme.palette.textOpacity.textMedium),
      marginTop: theme.spacing(2)
    })
  };
});
var YoutubePlayer = function YoutubePlayer(_ref) {
  var videoUrl = _ref.videoUrl,
    imageUrl = _ref.imageUrl,
    videoDescription = _ref.videoDescription;
  var classes = useStyles();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    videoId = _useState2[0],
    setVideoId = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    image = _useState4[0],
    setImage = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    videoConsent = _useState6[0],
    setVideoConsent = _useState6[1];
  useEffect(function () {
    var _window;
    handleConsent();
    // Handles consent when the user accepts/rejects cookies, changes cookie preferences
    (_window = window) === null || _window === void 0 || (_window = _window.OneTrust) === null || _window === void 0 || _window.OnConsentChanged(function () {
      handleConsent();
    });
  }, []);
  useEffect(function () {
    if (videoUrl) {
      setVideoId(getVideoId(videoUrl));
      setImage(imageUrl || "https://i3.ytimg.com/vi/".concat(getVideoId(videoUrl), "/maxresdefault.jpg"));
    }
  }, [videoUrl]);
  var handleConsent = function handleConsent() {
    var _window2;
    if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.OnetrustActiveGroups) !== null && _window2 !== void 0 && _window2.includes(ONETRUST_COOKIES_CATEGORIES.TARGETING)) {
      setVideoConsent(true);
    } else {
      setVideoConsent(false);
    }
  };
  var getVideoId = function getVideoId(videoUrl) {
    var id = videoUrl.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if (id) {
      return id[1];
    }
    return "";
  };
  var opts = {
    host: "https://www.youtube-nocookie.com"
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, videoId && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, videoConsent ? /*#__PURE__*/React__default.createElement(Youtube, {
    videoId: videoId,
    opts: opts,
    allow: "fullscreen",
    containerClassName: classes.root,
    className: classes.videoResponsive
  }) : /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    position: "relative"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: videoUrl,
    target: "_blank",
    rel: "noReferrer"
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(image, {
      width: 560,
      height: 300
    }),
    className: classes.ytVideoThumb,
    alt: image === null || image === void 0 ? void 0 : image.alt
  }), /*#__PURE__*/React__default.createElement(StreamlineIcon, {
    className: classes.playerIcon
  }, /*#__PURE__*/React__default.createElement(SvgButtonPlay, null)))), videoDescription && /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.descriptionText,
    align: "center"
  }, videoDescription)));
};
YoutubePlayer.propTypes = {
  videoUrl: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  videoDescription: PropTypes__default.string
};

export { YoutubePlayer as default };
//# sourceMappingURL=YoutubePlayer.js.map
